jQuery(($) => {
  if ( $('.o-notification-bar')[0] ) {
    var data_id = $('.o-notification-bar').attr('data-id');

    function pushHeaderDown() {
      if ($('.o-header').hasClass('o-header--notification-bar')) {
        var notificationBarHeight = $('.o-notification-bar').outerHeight();
        $('body').css('--notification-bar-height', `${notificationBarHeight}px`);
      }
    }

    if (localStorage.getItem('popState_' + data_id) != 'shown') {
        $('.o-notification-bar').css('display', 'flex');
        $('.o-header').addClass('o-header--notification-bar');

        pushHeaderDown();

        // On window resize, push header down
        $(window).resize(function () {
          pushHeaderDown();
        });
    }

    $('.o-notification-bar__close-button').click(function () {
        localStorage.setItem('popState_' + data_id, 'shown');

        $(this).remove();

        $('.o-notification-bar').slideUp();

        $('.o-header').removeClass('o-header--notification-bar');
        $('body').css('--notification-bar-height', `0px`);
    });
  }
});